import combineReducers from 'react-combine-reducers';

import PostReducer, { postDefaultState } from './PostReducer';
import Galleryreducer, { galleryDefaultState } from './GalleyReducer';

export const [combined, combinedState] = combineReducers({
  postReducer: [PostReducer, postDefaultState],
  galleryReducer: [Galleryreducer, galleryDefaultState],
});
